import { render } from "./MakeFinalSinglePayment.vue?vue&type=template&id=160c312e"
import script from "./MakeFinalSinglePayment.vue?vue&type=script&lang=js"
export * from "./MakeFinalSinglePayment.vue?vue&type=script&lang=js"

import exportComponent from "D:\\deploy\\fire-conference\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__